import '@nrk/dh-article-player/index.css'
export class TilpassetInnholdsvideo extends HTMLElement {
  player

  connectedCallback() {
    this.player = this.querySelector('dhas-article-player')
    window.addEventListener('resize', this._handleResize)
    setTimeout(() => {
      this._updateSource()
    }, 0)
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._handleResize)
  }

  _handleResize = () => {
    this._updateSource()
  }

  _updateSource() {
    const source = this._findSource()
    if (this.player.src !== source.src) {
      let wasPlaying = this.player.isPlaying
      this.player.suspend()
      this.player.src = source.src
      if (wasPlaying) {
        this.player.resume()
      }
    }
  }

  _findSource() {
    return this.sourcelist.find(
      (source) => !source.media || (window.matchMedia && window.matchMedia(source.media).matches)
    )
  }

  get sourcelist() {
    return JSON.parse(this.getAttribute('sources'))
  }
}
